import module from '@kendu/ui/module'
import './style.scss'

export class KdPaperComponent {
}

module.component('kdPaper', {
  controller: KdPaperComponent,
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-paper/component.js